/* eslint-disable no-useless-escape */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jul 19 2024
 **/

export const RegExp = {
	EMAIL_REG: /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i,

	PASSWORD_REG: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*\W).{8,24}$/,

	PHONE_REG: /^\d{2,3}-\d{3,4}-\d{4}$/,

	// 공백을 포함하여 텍스트를 분리하되, URL을 먼저 식별
	// TEXT_URL_REG: /(\bhttps?:\/\/[^\s]+)|(?:\s+)|([^\s]+)/g,
	TEXT_URL_REG: /(https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?::\d+)?(\/[^ \n]*)?/g,

	MAIL_REG: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g,

	// 특수 문자 체크
	ETC_TEXT_REG: /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g,

	ETC_TEXT_REG_FOR_CHAT: /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\\'\"]/,

	FILE_NAME_REG: /^[^\\/:*?"<>|]+$/,

	ENG_TEXT_REG: /[A-Za-z]$/,

	NUMBER_TEXT_REG: /[0-9]$/
} as const;
